// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"3396dfb1","404":"bf2d99da","498":"6ee3116e","513":"f99a8761","787":"edcbbaa2"}[chunkId] + ".chunk.js";
};